var _defs, _path, _polygon, _path2, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgToilettesMauvaisePosition3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "r\\xE9paration_toilettes",
    "data-name": "r\\xE9paration toilettes",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 460.38 764.16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{stroke:#fff;stroke-miterlimit:10;stroke-width:6px;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "toilettes mauvaise r\xE9ponse 3") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M983.76,1315.31V1198.18c-89-7.48-108.74-59-109.61-122.51h228.9v-245H1253.5v484.66Z",
    transform: "translate(-793.12 -551.15)"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "292.74 526.67 292.74 291.32 309.93 320.69 309.93 525.59 292.74 526.67"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M941,1075c-15,25-53,13-43.92-14.17,0,0,64.92-107.83,88.92-135.83-37-12-154.85-15.69-173-47-15.31-26.41-40.08-53.85,31.49-105.94L976.26,669.51c61.22-32.6,92.13,44.45,122.06,83L1220.71,870.2c12.63,22.6-5.5,49.42-28.93,40.9L1030.51,794.82s-96.6,33-94.51,44.18c51,13,95.81,28.61,138,62C1084.57,931.35,941,1075,941,1075Z",
    transform: "translate(-793.12 -551.15)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 336.19,
    cy: 79.02,
    r: 79
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgToilettesMauvaisePosition3);
export default __webpack_public_path__ + "static/media/toilettes_mauvaise_position_3.abb0928d40ef639908fbfc4fdd546542.svg";
export { ForwardRef as ReactComponent };